import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  e
} from "./chunk.D5EJUUKV.js";
import {
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/menu-item/menu-item-base.ts
var id = 0;
var menuItemSelectors = ["fadv-menu-item", "fadv-menu-category", "fadv-menu-item-checkbox", "fadv-menu-item-link"];
var FadvMenuItemBase = class extends s {
  constructor() {
    super(...arguments);
    this.componentId = `menu-item-${++id}`;
    this.hasSlot = new HasSlotController(this, "[default]", "prefix", "suffix");
    this.value = "";
    this.checked = false;
    this.disabled = false;
  }
  handleCheckedChange() {
    this.setAttribute("aria-checked", this.checked ? "true" : "false");
  }
  watchCheckState(oldValue, newValue) {
    if (oldValue === newValue)
      return;
    if ((oldValue === null || oldValue === void 0) && newValue === false)
      return;
    if (this.checked) {
      emit(this, "menu-item-checked");
    } else {
      emit(this, "menu-item-unchecked");
    }
  }
  handleDisabledChange() {
    this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
  }
  firstUpdated() {
    this.setAttribute("id", this.componentId);
    this.setAttribute("role", this.getRole());
  }
};
__decorateClass([
  e()
], FadvMenuItemBase.prototype, "value", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvMenuItemBase.prototype, "checked", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvMenuItemBase.prototype, "disabled", 2);
__decorateClass([
  watch("checked", { waitUntilFirstUpdate: true })
], FadvMenuItemBase.prototype, "handleCheckedChange", 1);
__decorateClass([
  watch("checked", { waitUntilFirstUpdate: true })
], FadvMenuItemBase.prototype, "watchCheckState", 1);
__decorateClass([
  watch("disabled", { waitUntilFirstUpdate: true })
], FadvMenuItemBase.prototype, "handleDisabledChange", 1);

export {
  menuItemSelectors,
  FadvMenuItemBase
};
